import moment from 'moment';
import {
  VISIT_ACTUAL_GET_SUCCESS,
  VISIT_ACTUAL_UPDATE_VISIT_TIME,
  VISIT_ACTUAL_ADD_ACTIVITY_TIME,
} from '../../../actions/constants/types';
import { parseDateUtc } from '../../../utils/dates';

const initialState = {
  activityTime: 0,
  duration: 0,
};

function getVisitDuration(value) {
  if (!value) {
    return 0;
  }

  if (!value.startAt || !value.endAt) {
    return 0;
  }

  const start = parseDateUtc(value.startAt);
  const end = parseDateUtc(value.endAt);

  return moment.duration(end.diff(start)).asMinutes();
}

function selectedDate(state = initialState, action) {
  switch (action.type) {
    case VISIT_ACTUAL_UPDATE_VISIT_TIME: {
      return {
        ...state,
        duration: action.time,
      };
    }
    case VISIT_ACTUAL_ADD_ACTIVITY_TIME: {
      return {
        ...state,
        activityTime: state.activityTime + action.time,
      };
    }
    case VISIT_ACTUAL_GET_SUCCESS: {
      const { visit } = action.response.data;
      return {
        activityTime: visit.minutes,
        duration: getVisitDuration(visit.actual),
      };
    }
    default: {
      return state;
    }
  }
}

export default selectedDate;
